module.exports = __webpack_public_path__ + "static/screen-previsioni-2c09407a2d13bba6b6a567d135374af6.png";